// prallax for home banner

window.addEventListener('scroll', function () {
  var homeBanners = document.getElementsByClassName('home-banner');

  Array.from(homeBanners).forEach(function (homeBanner) {
    var rect = homeBanner.getBoundingClientRect();
    var bannerImage = homeBanner.querySelector('.banner-image');

    // If the top of the banner is on or above the viewport and the bottom of the banner is on or below the viewport
    if (rect.top <= 0 && rect.bottom >= 0) {
      // Calculate the scroll position relative to the top of the banner
      var scroll = window.pageYOffset || document.documentElement.scrollTop;
      var relativeScroll = scroll - (rect.top + scroll);

      // Use the relative scroll position to move the image
      bannerImage.style.transform = 'translate3d(0, ' + relativeScroll * 0.5 + 'px, 0)';
    }
  });
});

$(document).ready(function () {
    var normalizeSizeDesc = function(sizeDesc) {
        var lowerCaseSizeDesc = sizeDesc.toLowerCase();
    
        // Remove date information from the size description
        var baseSizeDesc = lowerCaseSizeDesc.split("-expected")[0].trim();
    
        // Order matters: Check for "xl" variants before their base counterparts
        // if (baseSizeDesc.includes("xl twin")) return "xl-twin";
        // if (baseSizeDesc.includes("xl full")) return "xl-full";
        // // Then handle the rest of the cases
        // if (baseSizeDesc.includes("regular king")) return "regular-king";
        // if (baseSizeDesc.includes("california king")) return "california-king";
        // if (baseSizeDesc.includes("split king")) return "split-king";
        // if (baseSizeDesc.includes("twin")) return "twin";
        // if (baseSizeDesc.includes("full")) return "full";
        // if (baseSizeDesc.includes("queen")) return "queen";
        // if (baseSizeDesc.includes("xl king")) return "xl-king";
    
        // General normalization for any unexpected cases
        return baseSizeDesc.replace(/\s+/g, '-');
    };
    
    var changeDescription = function () {
        var sizeDesc = $(this).attr('data-size-desc');
        console.log('sizeDesc: ', sizeDesc); // Debugging
    
        var normalizedSizeDesc = normalizeSizeDesc(sizeDesc);
        var dataAttr = 'data-desc-' + normalizedSizeDesc;
        console.log('dataAttr: ', dataAttr); // Debugging
    
        var $descriptionSpan = $('.product-short-detail');
        var newDescription = $descriptionSpan.attr(dataAttr);
        console.log('newDescription: ', newDescription); // Debugging
    
        if (newDescription) {
            $descriptionSpan.text(newDescription);
        } else {
            var originalDesc = $descriptionSpan.attr('data-original-desc');
            $descriptionSpan.text(originalDesc);
        }
    };

     // Check for a pre-selected variant and update the description accordingly
    var preSelectedVariant = $('.product-form__input input[type="radio"]:checked');
    if (preSelectedVariant.length > 0) {
        changeDescription.call(preSelectedVariant);
    }

    // Attach the event listener for future changes
    $('.product-form__input input[type="radio"]').change(changeDescription);

  

  $('.collection-area__block a').hover(function () {
    $('.product-image.first', this).toggle();
  });


  //size modals
  // $('.show-size-guide').on('click', function () {
  //   $('#SelectSizeModal').show();
  //   // $('body').css('overflow', 'hidden');
  // });

  // $('.modal-content button.close').on('click', function () {
  //   $('#SelectSizeModal').hide();
  //   // $('body').css('overflow', 'auto');
  // });

  // // show / hide split head modal
  // var $splitHeadRadio = $('input[data-size-desc="split-head"]');
  // // If the 'split-head' option is already selected on page load
  // if ($splitHeadRadio.is(':checked')) {
  //   $('.ps-size-modal.split-v-head').show();
  // }
  // // Handle change event
  // $splitHeadRadio.change(function () {
  //   if ($(this).is(':checked')) {
  //     $('.ps-size-modal.split-v-head').show();

  //     $('html, body').scrollTop(0); // Scroll to the top of the page
  //   } else {
  //     $('.ps-size-modal.split-v-head').hide();
  //   }
  // });

  // // show / hide split king modal
  // var $splitKingRadio = $('input[data-size-desc="split-king"]');
  // // If the 'split-head' option is already selected on page load
  // if ($splitKingRadio.is(':checked')) {
  //   $('.ps-size-modal.split-v-king').show();
  // }
  // // Handle change event
  // $splitKingRadio.change(function () {
  //   if ($(this).is(':checked')) {
  //     $('.ps-size-modal.split-v-king').show();

  //     $('html, body').scrollTop(0); // Scroll to the top of the page
  //   } else {
  //     $('.ps-size-modal.split-v-king').hide();
  //   }
  // });

  // // show / hide Cali king modal
  // var $splitKingRadio = $('input[data-size-desc="california-king"]');
  // // If the 'split-head' option is already selected on page load
  // if ($splitKingRadio.is(':checked')) {
  //   $('.ps-size-modal.cali-v-king').show();
  // }
  // // Handle change event
  // $splitKingRadio.change(function () {
  //   if ($(this).is(':checked')) {
  //     $('.ps-size-modal.cali-v-king').show();

  //     $('html, body').scrollTop(0); // Scroll to the top of the page
  //   } else {
  //     $('.ps-size-modal.cali-v-king').hide();
  //   }
  // });

  // // show / hide xl-twin modal
  // var $XLTWINRadio = $('input[data-size-desc="xl-twin1"]');
  // // If the 'split-head' option is already selected on page load
  // if ($XLTWINRadio.is(':checked')) {
  //   $('.ps-size-modal.xl-size').show();
  // }
  // // Handle change event
  // $XLTWINRadio.change(function () {
  //   if ($(this).is(':checked')) {
  //     $('.ps-size-modal.xl-size').show();

  //     $('html, body').scrollTop(0); // Scroll to the top of the page
  //   } else {
  //     $('.ps-size-modal.xl-size').hide();
  //   }
  // });

  // $('.ps-size-modal-close').click(function (e) {
  //   e.preventDefault();
  //   $('.ps-size-modal').hide();
  // });

  $('.close-search').on('click', function () {
    $('.search-form-wrapper').hide();
    // $('body').css('overflow', 'auto');
  });

  $('.info-holder_search').on('click', function () {
    $('.search-form-wrapper').show();
    // $('body').css('overflow', 'auto');
  });
});

function onScroll(event) {
  var scrollPos = $(document).scrollTop();
  var navHeight = 70; // Height of the sticky nav

  $('.content--section').each(function () {
    var sectionId = $(this).attr('id');
    var sectionTop = $(this).offset().top - navHeight; // Apply the offset
    var sectionBottom = sectionTop + $(this).outerHeight();
    var navItem = $('[href="#' + sectionId + '"]').parent();

    if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
      $('.content--nav ul li').removeClass('active');
      navItem.addClass('active');
    } else {
      navItem.removeClass('active');
    }
  });
}

$(document).ready(function () {
  $(document).on('scroll', onScroll);

  $('a[href^="#"]').on('click', function (e) {
    if ($(this).attr('href') == "#recover" || $(this).attr('href') == "#login") {
      return true;
    }
    
    e.preventDefault();
    if(!this.hash) return;

    var target = this.hash;
    $target = $(target);

    // Calculate the offset, considering the sticky navigation header
    var offset = 69; // Height of the sticky nav
    var scrollToPosition = $target.offset().top - offset;

    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: scrollToPosition,
        },
        500,
        'swing',
        function () {
          // After animation, set active class on clicked link and remove from others
          $('a[href^="#"]').parent().removeClass('active');
          $('[href="' + target + '"]')
            .parent()
            .addClass('active');
        }
      );
  });
});
